var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.958,
    height: 100,
    viewBox: "0 0 91.958 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935",
    transform: "translate(-67.089 -19.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930",
    transform: "translate(67.089 43.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M82,88.627c-2.909-.98-5.816-1.97-8.729-2.936-1.928-.641-3.875-1.247-6.18-1.987,2.22-1.463,4.147-2.748,6.084-4.012q3.99-2.6,7.991-5.178c.909-.584.184-.864-.214-1.127-2.368-1.552-4.755-3.077-7.135-4.611l-6.388-4.116c.272-.71.881-.692,1.357-.846,8.868-2.877,17.748-5.718,26.6-8.63a3.511,3.511,0,0,1,3.4.465c4.048,2.722,8.161,5.347,12.273,7.975.381.243.371.515.4.843-1.13.408-2.248.851-3.391,1.217q-11.237,3.6-22.479,7.185a12.933,12.933,0,0,0-3.258,1.192c.846.287,1.529.528,2.218.751q13.595,4.408,27.192,8.81a2.4,2.4,0,0,1-1.048.979c-3.232,2.087-6.621,3.977-9.63,6.349-2.732,2.155-5.2,2.37-8.365,1.047C89.265,90.563,85.577,89.727,82,88.627Z",
    transform: "translate(-67.089 -54.853)",
    fill: "#c2d1d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M135.4,64.4c.035-.675.642-.826,1.064-1.108,4.027-2.673,8.072-5.319,12.1-7.993a2.388,2.388,0,0,1,2.339-.324c1.649.608,3.331,1.13,5.012,1.649.6.185,1.225.759,1.881.063a.467.467,0,0,1,.36,0c.332,1.384,1.662,1.115,2.544,1.412,5.922,1.995,11.881,3.88,17.828,5.8.318.1.8.154.815.5.022.489-.532.64-.877.864-4.018,2.6-8.053,5.174-12.073,7.772-1.408.91-1.373.9-.011,1.781,4.183,2.707,8.347,5.442,12.519,8.165.238.156.62.293.455.624-.1.2-.459.312-.722.4-4,1.281-8,2.543-12,3.831-.6.193-1.167.489-1.75.738-.568.133-1.148.227-1.7.406q-6.21,2-12.408,4.039a1.946,1.946,0,0,1-1.912-.155c-4.563-3.022-9.163-5.99-13.75-8.977l.016-.3,29.5-9.517a1.89,1.89,0,0,0-1.122-.572l-15.327-4.921C143.916,67.2,139.594,65.99,135.4,64.4Z",
    transform: "translate(-89.783 -54.81)",
    fill: "#c2d1d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M119.849,98.068c-.005.1-.011.2-.016.3-.505.487-.273,1.112-.274,1.67q-.031,18.281-.031,36.562a10.019,10.019,0,0,1-1.284-.241c-9.1-2.926-18.2-5.882-27.312-8.763-1.175-.371-1.442-.946-1.435-2.092.046-7.481.016-14.961.011-22.442,3.578,1.1,7.266,1.937,10.705,3.373,3.164,1.323,5.633,1.108,8.366-1.047,3.007-2.372,6.4-4.262,9.629-6.349a2.386,2.386,0,0,0,1.048-.979c.088-.018.177-.031.266-.041Z",
    transform: "translate(-74.572 -69.287)",
    fill: "#9bb2bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M134.654,136.775q.01-18.281.031-36.562c0-.559-.231-1.184.274-1.67,4.588,2.986,9.187,5.954,13.75,8.977a1.946,1.946,0,0,0,1.912.155q6.194-2.048,12.408-4.039c.553-.178,1.13-.273,1.7-.406q-.008,7.059-.017,14.117a8.85,8.85,0,0,0-8.786,6.986,12.686,12.686,0,0,0,.485,5.631q-9.887,3.181-19.776,6.357A4.836,4.836,0,0,1,134.654,136.775Z",
    transform: "translate(-89.644 -69.463)",
    fill: "#7596a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M119.694,88.386a2.6,2.6,0,0,0-.266.041l-27.192-8.81c-.688-.223-1.371-.465-2.218-.751a12.947,12.947,0,0,1,3.258-1.192q11.238-3.6,22.479-7.185c1.143-.366,2.261-.81,3.391-1.217l.574.047Q119.708,78.851,119.694,88.386Z",
    transform: "translate(-74.746 -59.655)",
    fill: "#59808d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M134.649,88.378q.013-9.534.027-19.068l.565-.066c4.2,1.585,8.518,2.8,12.784,4.177q7.659,2.475,15.327,4.921a1.883,1.883,0,0,1,1.122.573l-29.5,9.514ZM145.067,75.51c-.783-.056-1.309.193-1.475.842a1.035,1.035,0,0,0,.74,1.263h0c1.881.66,3.771,1.3,5.673,1.894a1.063,1.063,0,0,0,1.352-.66.947.947,0,0,0,.03-.1.979.979,0,0,0-.535-1.277,1,1,0,0,0-.094-.033c-1.922-.687-3.865-1.314-5.693-1.928Z",
    transform: "translate(-89.65 -59.646)",
    fill: "#7696a2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933",
    transform: "translate(133.025 90.952)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 7.06,
    cy: 7.06,
    r: 7.06,
    transform: "translate(1.765 1.765)",
    fill: "#c2d1d5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932",
    transform: "translate(1.765 1.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M177.872,129.8a7.059,7.059,0,0,0-6.963,11.83l6.963-3.017Z",
    transform: "translate(-168.753 -129.494)",
    fill: "#92acb5"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M174.924,126.84a8.825,8.825,0,0,0-8.825,8.824h0a8.825,8.825,0,1,0,8.825-8.825Zm0,15.885a7.06,7.06,0,0,1-7.06-7.059h0a7.06,7.06,0,1,1,7.06,7.06Z",
    transform: "translate(-166.099 -126.84)",
    fill: "#638794"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M182.644,132.2,175.1,143.923a7.06,7.06,0,0,0,1.146.391l7.229-11.237A7.118,7.118,0,0,0,182.644,132.2Z",
    transform: "translate(-169.115 -128.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M177.83,145.136a7.047,7.047,0,0,0,2.9-.18l5.08-7.989a7.016,7.016,0,0,0-1.068-2.706Z",
    transform: "translate(-170.03 -129.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M187.4,151.232c.492-.584.9-1.29,1.833-1.213,3.71,2.766,6.155,6.7,9.26,10.025.76.814,1.157,1.751.225,2.553a1.776,1.776,0,0,1-2.692-.395c-2.416-2.822-4.861-5.621-7.238-8.476C188.18,153,188.11,151.927,187.4,151.232Z",
    transform: "translate(-173.235 -134.605)",
    fill: "#7898a3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M132.174,67.309s-10-7.943,1.177-13.826c0,0,8.825-4.413,8.825-10.59,0,0-.295-5.295-5.883-4.118,0,0-5.293,3.024-1.176,7.984,0,0,10.883,9.372,20,1.136,0,0,10-8.237-3.236-20.592",
    transform: "translate(-20.362 -2.647)",
    fill: "none",
    stroke: "#37555e",
    strokeWidth: 1,
    strokeDasharray: "6 6 6 6 6 6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934",
    transform: "translate(126.511 19.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M157.675,22.115a2.778,2.778,0,0,1,.527-.256,3.493,3.493,0,0,1,.03-.612q-.121-.113-.256-.225c-.688-.561-1.4-.832-1.581-.6s.222.864.91,1.427A4.529,4.529,0,0,0,157.675,22.115Z",
    transform: "translate(-156.351 -19.716)",
    fill: "#9bb2bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M160.631,21.771c-.059-.221-.324-.36-.69-.406.019-.088.036-.178.049-.271.125-.878-.08-1.634-.457-1.688s-.784.615-.909,1.494a3.557,3.557,0,0,0-.033.646c-.7.255-1.162.694-1.064,1.049.107.4.888.545,1.746.317S160.738,22.174,160.631,21.771Z",
    transform: "translate(-156.741 -19.404)",
    fill: "#37555e"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 0.882,
    cy: 0.882,
    r: 0.882,
    transform: "translate(93.241 36.128)",
    fill: "none",
    stroke: "#c2d1d5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 0.588,
    cy: 0.588,
    r: 0.588,
    transform: "translate(103.106 28.92)",
    fill: "none",
    stroke: "#c2d1d5",
    strokeWidth: 0.667
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.2ed9da3162ff941ccc42dff14816b8bf.svg";
export { ForwardRef as ReactComponent };